import { __extends, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import { Button } from '../Button/Button.component.js';
import { propTypes, defaultProps } from './ContextualSaveBar.types.js';
import styles from './ContextualSaveBar.module.scss.js';

var ACTION_MAX_INDEX = 3;
var ContextualSaveBar = /** @class */ (function (_super) {
    __extends(ContextualSaveBar, _super);
    function ContextualSaveBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContextualSaveBar.prototype.componentDidMount = function () {
        if (Array.isArray(this.props.actions) &&
            this.props.actions.length > 3) {
            console.warn('WARNING: You pass more than 3 actions. Only the first 3 will be rendered');
        }
    };
    ContextualSaveBar.prototype.render = function () {
        var _a = this.props, className = _a.className, status = _a.status, actions = _a.actions, withSidebar = _a.withSidebar;
        return (React__default.createElement("div", { className: clsx(styles.ContextualSaveBar, withSidebar && styles.ContextualSaveBar___withSidebar, className) },
            React__default.createElement("div", { className: styles.ContextualSaveBar_content },
                React__default.createElement("div", { className: styles.ContextualSaveBar_status }, status),
                React__default.createElement("div", { className: styles.ContextualSaveBar_actions }, Array.isArray(actions) &&
                    actions.map(function (item, index) {
                        return index < ACTION_MAX_INDEX && (React__default.createElement(Button, __assign({ className: styles.ContextualSaveBar_button, key: item.title + "-" + (item.variant || '') + "-" + index }, item), item.title));
                    })))));
    };
    ContextualSaveBar.displayName = 'ContextualSaveBar';
    ContextualSaveBar.propTypes = propTypes;
    ContextualSaveBar.defaultProps = __assign({}, defaultProps);
    return ContextualSaveBar;
}(React__default.Component));

export { ContextualSaveBar, ContextualSaveBar as default };
